import axios from "axios";

export default {
  state: {
    currentBasemap: localStorage.basemap || "HereStreets"
  },
  mutations: {
    setCurrentBasemap(state, basemap) {
      state.currentBasemap = basemap;
      localStorage.basemap = basemap;
    }
  },
  getters: {
    getCurrentBasemap(state) {
      return state.currentBasemap;
    }
  },
  actions: {
    async getAttributesConfig(ctx, id) {
      try {
        return await axios.get(`/projects/${id}/offers_attributes_config`);
      } catch (e) {
        return e.response.data.message;
      }
    },
    async saveAttributesConfig(ctx, { id, body }) {
      try {
        return await axios.put(
          `/projects/${id}/offers_attributes_config`,
          body
        );
      } catch (e) {
        return e.response.data.message;
      }
    },
    addProjectLink(ctx, payload) {
      const { id } = payload;
      delete payload.id;
      return axios
        .post(`/projects_links/${id}`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    acceptProjectEditing(ctx, payload) {
      let id = payload.id;
      delete payload["id"];
      return axios
        .put(`/projects/${id}`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    editProjectLink(ctx, payload) {
      const id = payload.id;
      const uuid = payload.uuid;
      delete payload.id;
      delete payload.uuid;
      return axios
        .put(`/projects_links/${id}/${uuid}`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    deleteLink(ctx, payload) {
      let id = payload.id;
      let uuid = payload.uuid;
      delete payload["id"];
      delete payload["uuid"];
      return axios
        .delete(`/projects_links/${id}/${uuid}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    editProjectOfferAttributes(ctx, data) {
      return axios
        .put("/projects_offers", null, { params: data })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    }
  }
};
